<script>
	import formBase from '@_system/components/base/form.vue'
	import audit from './audit/index.vue'
	export default {
		extends: formBase,
		name: 'contractForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<audit form={this} comapnyid={this.comapnyid} type={this.type} row={this.row} ref="audit" />
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				auditShow:false,
				row:null,
				type:'preview',
				comapnyid:0
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next){
				formData.taxid = formData.taxid.toUpperCase()
				formData.taxid = formData.taxid.replace(new RegExp('O', 'g'), '0')
				this.fApi.setValue('taxid',formData.taxid)
				
	
				if(formData.isinvoice == 5 && !formData.email){
					this.$message.error('开票邮箱必填')
					return
				}
				
				next()
			},
			ordercodeButton(component) {
				return new Promise((reslove)=>{
					let ordercode = this.fApi.getValue('ordercode')
					if (ordercode) {
						component.el.loading = true
						this.$api.contract.listTrades(ordercode, {
							ordercode:ordercode,
						}).then((res) => {
							component.el.loading = false
							let collectionamount = 0
							let post_fee = 0
							let cost = 0
							let profit = 0
							res.forEach((item)=>{
								collectionamount += item.real_payment
								post_fee += item.post_fee
								cost += item.cost
							})
							//console.log(collectionamount,cost,post_fee,collectionamount*0.1)
							if(collectionamount){
								profit = (collectionamount - cost - post_fee - collectionamount*0.1)/collectionamount
								profit *= 100
							}
							
							this.fApi.setValue('collectionamount',collectionamount)
							this.fApi.setValue('profit',profit.toFixed(2))
							//console.log(post_fee)
							reslove()
					
						}, () => {
							component.el.loading = false
							reslove()
						})
					} else {
						component.el.loading = false
						this.$message.error('请填写订单编号')
						reslove()
					}
				})
			},
			taxidButton() {
				let taxid = this.fApi.getValue('taxid')
				if (taxid) {
					this.$api.invoiceoutput.searchinvoicetaxid(taxid).then((res) => {
						if (!res) {
							this.$message.error('暂无企业信息')
						} else {
							this.fApi.setValue('buyer', res.invoicetitle)
							//console.log(res)
							// for (let i in res) {
							// 	this.fApi.setValue(i, res[i])
							// }
							//this.fApi.setValue(this.getItemValue(res.data[0]))
						}
			
					})
				} else {
					this.$message.error('请填企业税号')
				}
			},
			regestEvent(rule, fApi) {
				let $son_contract_file = fApi.el('$son_contract_file')
				$son_contract_file.audit = this.audit
				$son_contract_file.preview = this.preview
			},
			audit(row) {
				this.type = 'audit'
				this.row = row
				this.comapnyid = this.fApi.getValue('comapnyid')
				this.$refs.audit.modalShow = true
			},
			preview(row){
				this.type = 'preview'
				this.row = row
				this.comapnyid = this.fApi.getValue('comapnyid')
				this.$refs.audit.modalShow = true
			},
			tablefieldChange(e){
				//console.log(e)
				if(e.data.column.field=='file'){
					let filename = e.data.row.file[0].name
					e.data.row.audit = 6
					e.data.row.name = filename
					this.fApi.setValue('buyer',filename.split('-')[0])
				}
			}
		},
		components: {

		}
	}
</script>
